import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiResponse, BaseComponent} from 'compob2b-libs';
import {FileUploader} from 'ng2-file-upload';
import {from, Observable, Subject, Subscription} from 'rxjs';
import {concatMap, finalize, map, takeUntil, tap} from 'rxjs/operators';

interface DocumentFile {
  enabled: boolean;
  header: string;
  fileInput: File;
}

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent extends BaseComponent implements OnInit {
  constructor(protected readonly route: ActivatedRoute) {
    super();
  }

  uploader: FileUploader;
  isUploading = false;
  finished = false;
  menuId: number = 0;
  progress = 0;

  files = [];
  hasDropZoneOver: boolean;
  interval = null;
  uploadURI: string;

  private subscription: Subscription;

  readonly uploading = new Subject<boolean>();

  ngOnInit() {
    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 4000 * 1024 * 1024,
    });

    this.route.queryParamMap.pipe(
      tap(params => {
        if (params.get('catalog_id') === null || params.get('catalog_id') === undefined) {
          this.menuId = 0;
        } else {
          this.menuId = Number(params.get('catalog_id'));
        }

      }),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe),
    ).subscribe();
  }

  getProgressStyle(progress: number) {
    return `stroke-dashoffset: calc(310 - (310 * ${progress}) / 100)`;
  }

  restart() {
    this.isUploading = false;
    this.finished = false;
    this.progress = 0;
    this.files = [];
    this.subscription.unsubscribe();
    this.uploading.next(false);
    this.uploader.clearQueue();
    this.cdr.detectChanges();
  }

  public upload(): void {
    console.log('uploader event', this.uploader);
    this.isUploading = true;
    this.uploading.next(true);
    this.progress = 0;
    this.files = [];
    if (this.uploader.queue.length) {
      this.subscription = from(this.uploader.queue)
        .pipe(
          map(uploadingFile => uploadingFile._file),
          concatMap(uploadingFile => this.uploadFile(uploadingFile)),
          tap(response1 => {
            if (response1.progress != undefined) {
              this.progress = response1.progress;
            }
            console.log(response1);
            if ('response' in response1) {
              let response = response1.response;
              console.log(response);
              if (response != undefined && 'success' in response && !response.success) {
                const link = response.data !== 'Entity already presented' ? '<a href="/cabinet/dam/item/edit/${response.data}" target="_blank"></a>' : '';
                this.warningToast('Данный файл уже загружен ранее' + link);
              }
              if (response != undefined && 'success' in response && response.success) {
                this.files.push(response1.response);
              }
              this.progress = 0;
            }
            this.cdr.detectChanges();
          }),
          finalize(() => this.finishUpload()),
          takeUntil(this.unsubscribe)
        ).subscribe();
      this.hasDropZoneOver = false;
    }
  }

  public fileOver(e: any): void {
    this.hasDropZoneOver = e;
  }

  private finishUpload(): void {
    console.log('finishUpload1');
    this.uploader.clearQueue();
    this.subscription.unsubscribe();
    this.isUploading = false;
    this.finished = true;
    this.isUploading = false;
    this.uploading.next(false);
    this.cdr.detectChanges();
  }

  private uploadFile(uploadingFile: File): Observable<{ progress?: number, response?: ApiResponse<string> }> {
    console.log('uploadFile Type of File', uploadingFile instanceof File);
    console.log('uploadFile Argument', uploadingFile);
    this.uploadURI = '/dam/upload/' + this.menuId;
    return this.compoApiService.postFormWithProgress<DocumentFile, string>(
      this.uploadURI, {enabled: true, header: uploadingFile?.name, fileInput: uploadingFile}
    );
  }

}
